import React, { createContext, useContext, useEffect, useState } from 'react';
import { CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js';
import Pool from '../UserPool';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authenticated, setAuthenticated] = useState(false);
  const [userEmail, setUserEmail] = useState('');

  useEffect(() => {
    // Check if tokens and user email are in storage on component mount
    checkTokensAndEmail();
  }, []);

  const checkTokensAndEmail = () => {
    const storedAccessToken = localStorage.getItem('accessToken');
    const storedIdToken = localStorage.getItem('idToken');
    const storedRefreshToken = localStorage.getItem('refreshToken');
    const storedUserEmail = localStorage.getItem('userEmail');

    if (storedAccessToken && storedIdToken && storedRefreshToken && storedUserEmail) {
      setAuthenticated(true);
      setUserEmail(storedUserEmail);
    } else {
      setAuthenticated(false);
      setUserEmail('');
    }
  };

  const saveTokensAndEmailToStorage = (accessToken, idToken, refreshToken, userEmail) => {
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('idToken', idToken);
    localStorage.setItem('refreshToken', refreshToken);
    localStorage.setItem('userEmail', userEmail);
  };

  const authenticate = async (Username, Password) => {
    return new Promise((resolve, reject) => {
      const user = new CognitoUser({ Username, Pool });
      const authDetails = new AuthenticationDetails({ Username, Password });

      user.authenticateUser(authDetails, {
        onSuccess: (session) => {
          const userEmail = user.getUsername(); // Assuming email is the username
          saveTokensAndEmailToStorage(
            session.getAccessToken().getJwtToken(),
            session.getIdToken().getJwtToken(),
            session.getRefreshToken().getToken(),
            userEmail
          );

          // Set authenticated and user email
          setAuthenticated(true);
          setUserEmail(userEmail);

          resolve({ newChallengeRequired: false, session });
        },
        onFailure: (err) => {
          console.error('Authentication failed: ', err);
          // Set authenticated and user email to false on failure
          setAuthenticated(false);
          setUserEmail('');
          reject(err);
        },
        newPasswordRequired: (session) => {
          console.log('New password required: ', session);
          // Set authenticated and user email to false when a new password is required
          setAuthenticated(false);
          setUserEmail('');
          resolve({ newChallengeRequired: true, session });
        },
      });
    });
  };

  const logout = () => {
    // Remove tokens and user email from storage
    localStorage.removeItem('accessToken');
    localStorage.removeItem('idToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('userEmail');

    // Set authenticated and user email to false
    setAuthenticated(false);
    setUserEmail('');

    const user = Pool.getCurrentUser();
    if (user) {
      user.signOut();
    }
  };

  return (
    <AuthContext.Provider
      value={{
        authenticated,
        userEmail,
        authenticate,
        logout,
        checkTokensAndEmail,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => useContext(AuthContext);